import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
var FlightbridgeService = /** @class */ (function () {
    function FlightbridgeService(_http, _errorHandler) {
        this._http = _http;
        this._errorHandler = _errorHandler;
    }
    FlightbridgeService.prototype.postFlightBridgeSSOInitial = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var URL, BODY;
            return tslib_1.__generator(this, function (_a) {
                URL = environment.airportsApiUrl + "/customer/flightbridgesso";
                try {
                    BODY = {};
                    return [2 /*return*/, this._http.post(URL, BODY).toPromise()];
                }
                catch (e) {
                    this._errorHandler.handleError(e);
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    return FlightbridgeService;
}());
export { FlightbridgeService };
